import { render, staticRenderFns } from "./CreatePortfolioOperationModalWrapper.vue?vue&type=template&id=608b7084"
import script from "./CreatePortfolioOperationModalWrapper.vue?vue&type=script&lang=js"
export * from "./CreatePortfolioOperationModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports